import { render, staticRenderFns } from "./EditSlideDeckSection.modal.vue?vue&type=template&id=15f95598"
import script from "./EditSlideDeckSection.modal.vue?vue&type=script&lang=ts"
export * from "./EditSlideDeckSection.modal.vue?vue&type=script&lang=ts"
import style0 from "./EditSlideDeckSection.modal.vue?vue&type=style&index=0&id=15f95598&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports